export default __webpack_public_path__ + "11061a204a1870a1c2c6cb86c566222e.png";